import { EventChannelList, notifyEventChannel } from 'helpers/event-center';
import { OrderStatus } from 'models/order';

export default function onChangeStatusSuccess(showAll: boolean, orderStatus: OrderStatus[]) {
  const completeOrderId = orderStatus.find(status => status.status === 'Order Complete')?.id;
  return (payload) => !showAll && payload.orderStatus === completeOrderId
    ? notifyEventChannel(EventChannelList.ORDERS_LIST_CHANGED) : null;
}
